// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__28YzP","rightAdornment":"Header_rightAdornment__2nN-y"};